export default __webpack_public_path__ + "static/media/151-calculations.659c35f4.png";